import { Button } from "../components/ui/button"
import { Input } from "../components/ui/input"
import { Badge } from "../components/ui/badge"
import { Card } from "../components/ui/card"
import { Progress } from "../components/ui/progress"
import { Avatar } from "../components/ui/avatar"
import { Bell, Search, Clock, Calendar, Gem, Briefcase, Link as LucideLink, FileText, Check, ChevronRight, Home as HomeIcon, ArrowLeft, Star as StarIcon } from "lucide-react"
import { useState, useEffect } from "react"
import { ThemeToggle } from "../components/theme-toggle"
import { ThemeProvider } from "../components/theme-provider"
import { Link, useNavigate, useLocation } from "react-router-dom"
import Profile from "./Profile"
import { useAuth } from "../contexts/AuthContext"
import '../index.css';
import Sidebar from "../components/Sidebar"
import GigCard from "../components/GigCard"
import ProjectCard from "../components/ProjectCard"
// import Navbar from "../components/Navbar"

// Dummy Data
const BOUNTIES = [
  {
    id: 1,
    company: "EIGEN LAYER",
    title: "Design the new website for Eigen Layer",
    amount: "1200 USDC",
    dueTime: "12h",
    type: "Bounty",
    comments: 5,
    category: "DESIGN",
    criteria: [
      'Creativity and originality',
      'Alignment with Superteam Germany',
      'Quality of design and presentation',
    ],
  },
  {
    id: 2,
    company: "Base",
    title: "Develop Smart Contract Testing Framework",
    amount: "2500 USDC",
    dueTime: "2d",
    type: "Bounty",
    comments: 3,
    category: "DEVELOPMENT",
    criteria: [
      'onchain score of 90',
      'github score greater than 100',
      'builder score',
    ],
  },
  {
    id: 3,
    company: "Optimism",
    title: "Create Educational Content for L2",
    amount: "800 USDC",
    dueTime: "5d",
    type: "Bounty",
    comments: 8,
    category: "CONTENT",
    criteria: [
      'Clarity of explanation',
      'Technical accuracy',
      'Engagement',
    ],
  },
  {
    id: 4,
    company: "Superteam",
    title: "Design a mascot for Superteam",
    amount: "600 USDC",
    dueTime: "1d",
    type: "Bounty",
    comments: 2,
    category: "DESIGN",
    criteria: [
      'Mascot creativity',
      'Brand alignment',
    ],
  },
  {
    id: 5,
    company: "Solana",
    title: "Write a technical blog post about Solana",
    amount: "400 USDC",
    dueTime: "3d",
    type: "Bounty",
    comments: 4,
    category: "CONTENT",
    criteria: [
      'Technical depth',
      'Clarity',
    ],
  },
  {
    id: 6,
    company: "Polygon",
    title: "Build a Polygon NFT Gallery",
    amount: "1500 USDC",
    dueTime: "4d",
    type: "Bounty",
    comments: 6,
    category: "DEVELOPMENT",
    criteria: [
      'UI/UX',
      'Smart contract quality',
    ],
  },
  {
    id: 7,
    company: "Aave",
    title: "Create a meme campaign for Aave",
    amount: "300 USDC",
    dueTime: "2d",
    type: "Bounty",
    comments: 1,
    category: "OTHERS",
    criteria: [
      'Virality',
      'Creativity',
    ],
  },
  {
    id: 8,
    company: "Arbitrum",
    title: "Build a Bridge UI for Arbitrum",
    amount: "2000 USDC",
    dueTime: "3d",
    type: "Bounty",
    comments: 4,
    category: "DEVELOPMENT",
    criteria: [
      'UI/UX quality',
      'Security considerations',
      'Documentation',
    ],
  },
  {
    id: 9,
    company: "Starknet",
    title: "Create a Starknet Tutorial Series",
    amount: "1500 USDC",
    dueTime: "7d",
    type: "Bounty",
    comments: 6,
    category: "CONTENT",
    criteria: [
      'Technical accuracy',
      'Beginner-friendly',
      'Code examples',
    ],
  },
]

const IN_PROGRESS_BOUNTIES = [
  {
    id: 10,
    company: "Polygon",
    title: "Build a Polygon NFT Gallery",
    amount: "1500 USDC",
    dueTime: "4d",
    type: "Bounty",
    comments: 6,
    category: "DEVELOPMENT",
    criteria: [
      'UI/UX',
      'Smart contract quality',
    ],
  },
  {
    id: 11,
    company: "Aave",
    title: "Create a meme campaign for Aave",
    amount: "300 USDC",
    dueTime: "2d",
    type: "Bounty",
    comments: 1,
    category: "OTHERS",
    criteria: [
      'Virality',
      'Creativity',
    ],
  },
]

const COMPLETED_BOUNTIES = [
  {
    id: 12,
    company: "Optimism",
    title: "Create Educational Content for L2",
    amount: "800 USDC",
    dueTime: "Completed",
    type: "Bounty",
    comments: 8,
    category: "CONTENT",
    criteria: [
      'Clarity of explanation',
      'Technical accuracy',
      'Engagement',
    ],
  },
  {
    id: 13,
    company: "Superteam",
    title: "Design a mascot for Superteam",
    amount: "600 USDC",
    dueTime: "Completed",
    type: "Bounty",
    comments: 2,
    category: "DESIGN",
    criteria: [
      'Mascot creativity',
      'Brand alignment',
    ],
  },
]

const PROJECTS = [
  {
    id: 1,
    name: "DeFi Protocol",
    description: "Building next-gen DeFi infrastructure",
    tech: ["Solidity", "React", "Node.js"],
    applied: 12,
    stars: 156,
    category: "DEVELOPMENT",
    status: "open"
  },
  {
    id: 2,
    name: "NFT Marketplace",
    description: "Decentralized marketplace for digital assets",
    tech: ["TypeScript", "Next.js", "Hardhat"],
    applied: 8,
    stars: 89,
    category: "DEVELOPMENT",
    status: "inprogress"
  },
  {
    id: 3,
    name: "DAO Tools",
    description: "Governance tools for DAOs",
    tech: ["React", "Python", "Solidity"],
    applied: 15,
    stars: 234,
    category: "DEVELOPMENT",
    status: "completed"
  },
  {
    id: 4,
    name: "Design System Kit",
    description: "Reusable design system for web3 apps",
    tech: ["Figma", "CSS", "React"],
    applied: 5,
    stars: 45,
    category: "DESIGN",
    status: "open"
  },
  {
    id: 5,
    name: "Crypto Blog Platform",
    description: "A platform for crypto-related articles and tutorials",
    tech: ["Markdown", "Next.js", "TypeScript"],
    applied: 10,
    stars: 67,
    category: "CONTENT",
    status: "completed"
  },
  {
    id: 6,
    name: "Web3 Podcast Aggregator",
    description: "Podcast aggregator for blockchain content",
    tech: ["RSS", "React", "Node.js"],
    applied: 3,
    stars: 22,
    category: "CONTENT",
    status: "open"
  },
  {
    id: 7,
    name: "Community Event Platform",
    description: "Platform for organizing and joining web3 events",
    tech: ["React", "Firebase", "TailwindCSS"],
    applied: 7,
    stars: 31,
    category: "OTHERS",
    status: "inprogress"
  },
  {
    id: 8,
    name: "ZK Voting App",
    description: "Zero-knowledge voting for DAOs",
    tech: ["ZK-SNARKs", "TypeScript", "React"],
    applied: 4,
    stars: 54,
    category: "DEVELOPMENT",
    status: "open"
  },
  {
    id: 9,
    name: "Token Gated Content",
    description: "Unlock content with your wallet tokens",
    tech: ["Solidity", "Next.js", "Web3.js"],
    applied: 6,
    stars: 39,
    category: "CONTENT",
    status: "inprogress"
  },
  {
    id: 10,
    name: "NFT Art Generator",
    description: "Generate and mint NFT art collections",
    tech: ["Python", "React", "Solidity"],
    applied: 9,
    stars: 73,
    category: "DESIGN",
    status: "completed"
  },
  {
    id: 11,
    name: "DeFi Yield Dashboard",
    description: "Track and optimize DeFi yields",
    tech: ["React", "Node.js", "Solidity"],
    applied: 11,
    stars: 120,
    category: "DEVELOPMENT",
    status: "open"
  },
  {
    id: 12,
    name: "Web3 Social Feed",
    description: "Decentralized social media feed",
    tech: ["React", "IPFS", "Ethereum"],
    applied: 13,
    stars: 88,
    category: "CONTENT",
    status: "completed"
  },
]

const IN_PROGRESS_PROJECTS = [
  {
    id: 13,
    name: "NFT Marketplace",
    description: "Decentralized marketplace for digital assets",
    tech: ["TypeScript", "Next.js", "Hardhat"],
    applied: 8,
    stars: 89,
    category: "DEVELOPMENT",
    status: "inprogress"
  },
  {
    id: 14,
    name: "Community Event Platform",
    description: "Platform for organizing and joining web3 events",
    tech: ["React", "Firebase", "TailwindCSS"],
    applied: 7,
    stars: 31,
    category: "OTHERS",
    status: "inprogress"
  },
]

const COMPLETED_PROJECTS = [
  {
    id: 15,
    name: "DAO Tools",
    description: "Governance tools for DAOs",
    tech: ["React", "Python", "Solidity"],
    applied: 15,
    stars: 234,
    category: "DEVELOPMENT",
    status: "completed"
  },
  {
    id: 16,
    name: "Crypto Blog Platform",
    description: "A platform for crypto-related articles and tutorials",
    tech: ["Markdown", "Next.js", "TypeScript"],
    applied: 10,
    stars: 67,
    category: "CONTENT",
    status: "completed"
  },
]

const MOCK_BOUNTY_DETAIL = {
  about: `Germany's Superteam is calling on all creative minds to design amazing merch! This is your opportunity to design exclusive t-shirts, stickers, and more that represent the essence of Superteam Germany and the Solana ecosystem.\n\nSome of the winning designs will get turned into physical merch!`,
  interested: 16,
  avatars: [
    'https://randomuser.me/api/portraits/men/32.jpg',
    'https://randomuser.me/api/portraits/women/44.jpg',
    'https://randomuser.me/api/portraits/men/45.jpg',
    'https://randomuser.me/api/portraits/women/46.jpg',
  ],
  evolutionCriteria: [
    'Creativity and originality',
    'Alignment with Superteam Germany',
    'Quality of design and presentation',
  ],
  prizes: [
    { label: 'First Prize', amount: 800 },
    { label: 'Second Prize', amount: 400 },
    { label: 'Third Prize', amount: 200 },
  ],
  deadline: '1d:14h:13m',
}

// ProfileCompletion component
const ProfileCompletion = ({ percent, steps }: { percent: number, steps: { label: string, done: boolean }[] }) => {
  return (
    <div className="bg-card rounded-lg p-4 shadow-md mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="uppercase text-xs text-muted-foreground tracking-widest">Your profile is</div>
          <div className="text-lg font-bold">{percent}% completed</div>
        </div>
        <div className="relative w-10 h-10">
          <svg className="w-10 h-10" viewBox="0 0 40 40">
            <circle cx="20" cy="20" r="18" fill="none" stroke="#222" strokeWidth="4" opacity="0.2" />
            <circle
              cx="20" cy="20" r="18" fill="none" stroke="#22c55e" strokeWidth="4"
              strokeDasharray={2 * Math.PI * 18}
              strokeDashoffset={2 * Math.PI * 18 * (1 - percent / 100)}
              strokeLinecap="round"
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-primary">{percent}%</span>
        </div>
      </div>
      <ul className="space-y-2">
        {steps.map((step, i) => (
          <li key={i} className="flex items-center gap-2 text-sm">
            {step.done ? (
              <Check className="w-4 h-4 text-green-500" />
            ) : (
              <div className="w-4 h-4 rounded-full border border-muted-foreground flex items-center justify-center">
                <span className="block w-2 h-2 bg-muted-foreground rounded-full" />
              </div>
            )}
            <span className={step.done ? 'line-through text-muted-foreground' : ''}>{step.label}</span>
            <span className="ml-auto">
              {step.done ? <Check className="w-4 h-4 text-green-500" /> : <ChevronRight className="w-4 h-4 text-muted-foreground" />}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Beautified Leaderboard component
const Leaderboard = ({ leaders }: { leaders: { name: string, score: number, avatar: string }[] }) => {
  return (
    <div className="bg-[#FAF94F] rounded-lg p-4 shadow-md mb-6 border-2 border-black">
      <div className="font-semibold mb-2 text-black tracking-wide">Leaderboard</div>
      <ul className="space-y-2">
        {leaders.map((leader, idx) => (
          <li key={leader.name} className={`flex items-center gap-2 text-sm p-2 rounded-lg ${idx < 3 ? 'bg-white/50' : ''}`}>
            <span className="font-bold w-5 text-center text-black">{idx + 1}</span>
            <img src={leader.avatar} alt={leader.name} className={`w-7 h-7 rounded-full border-2 ${idx === 0 ? 'border-yellow-400' : idx === 1 ? 'border-gray-400' : idx === 2 ? 'border-orange-400' : 'border-muted'}`} />
            <span className="font-medium flex-1 text-black">{leader.name}</span>
            <span className="font-mono text-right text-black">{leader.score}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

// RecentActivity component
const RecentActivity = ({ activities }: { activities: { name: string, handle: string, avatar: string, action: string, time: string }[] }) => {
  return (
    <div className="bg-card rounded-lg p-4 shadow-md">
      <div className="uppercase text-xs text-muted-foreground tracking-widest mb-2">Recent Activity</div>
      <ul className="space-y-3">
        {activities.map((activity, i) => (
          <li key={i} className="flex items-center gap-3">
            <img src={activity.avatar} alt={activity.name} className="w-8 h-8 rounded-full" />
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{activity.name} <span className="text-muted-foreground text-xs">{activity.handle}</span></div>
              <div className="text-xs text-muted-foreground truncate">{activity.action}</div>
            </div>
            <div className="text-xs text-muted-foreground whitespace-nowrap">{activity.time}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

type MainTab = "bounties" | "projects" | "leaderboard";

interface HomeProps {
  mainTab: MainTab;
  setMainTab: (tab: MainTab) => void;
}

const Home = ({ mainTab, setMainTab }: HomeProps) => {
  const [bountySubTab, setBountySubTab] = useState<'open' | 'inprogress' | 'completed'>('open');
  const [projectSubTab, setProjectSubTab] = useState<'open' | 'inprogress' | 'completed'>('open');
  const [activeCategory, setActiveCategory] = useState("ALL")
  const [selectedBounty, setSelectedBounty] = useState<typeof BOUNTIES[0] | null>(null)
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const categories = ["ALL", "DESIGN", "DEVELOPMENT", "CONTENT", "OTHERS"]

  // Dummy data for now, replace with API data later
  const [profilePercent, setProfilePercent] = useState(25);
  const [profileSteps, setProfileSteps] = useState([
    { label: 'Create basic profile', done: true },
    { label: 'Social links', done: false },
    { label: 'Add proof of work', done: false },
  ]);
  const [leaders, setLeaders] = useState([
    { name: 'Alice', score: 120, avatar: 'https://randomuser.me/api/portraits/women/1.jpg' },
    { name: 'Bob', score: 110, avatar: 'https://randomuser.me/api/portraits/men/2.jpg' },
    { name: 'Charlie', score: 100, avatar: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: 'Diana', score: 90, avatar: 'https://randomuser.me/api/portraits/women/4.jpg' },
    { name: 'Eve', score: 80, avatar: 'https://randomuser.me/api/portraits/women/5.jpg' },
    { name: 'Frank', score: 75, avatar: 'https://randomuser.me/api/portraits/men/6.jpg' },
    { name: 'Grace', score: 70, avatar: 'https://randomuser.me/api/portraits/women/7.jpg' },
    { name: 'Heidi', score: 65, avatar: 'https://randomuser.me/api/portraits/women/8.jpg' },
    { name: 'Ivan', score: 60, avatar: 'https://randomuser.me/api/portraits/men/9.jpg' },
    { name: 'Judy', score: 55, avatar: 'https://randomuser.me/api/portraits/women/10.jpg' },
    { name: 'Mallory', score: 50, avatar: 'https://randomuser.me/api/portraits/women/11.jpg' },
    { name: 'Oscar', score: 45, avatar: 'https://randomuser.me/api/portraits/men/12.jpg' },
    { name: 'Peggy', score: 40, avatar: 'https://randomuser.me/api/portraits/women/13.jpg' },
    { name: 'Sybil', score: 35, avatar: 'https://randomuser.me/api/portraits/women/14.jpg' },
    { name: 'Trent', score: 30, avatar: 'https://randomuser.me/api/portraits/men/15.jpg' },
    { name: 'Victor', score: 25, avatar: 'https://randomuser.me/api/portraits/men/16.jpg' },
    { name: 'Walter', score: 20, avatar: 'https://randomuser.me/api/portraits/men/17.jpg' },
  ]);
  const [activities, setActivities] = useState([
    { name: 'Sam Altman', handle: '@sam', avatar: 'https://randomuser.me/api/portraits/men/11.jpg', action: 'Submitted a bounty', time: '12s ago' },
    { name: 'Sam Altman', handle: '@sam', avatar: 'https://randomuser.me/api/portraits/men/11.jpg', action: 'Submitted a bounty', time: '12s ago' },
    { name: 'Sam Altman', handle: '@sam', avatar: 'https://randomuser.me/api/portraits/men/11.jpg', action: 'Submitted a bounty', time: '12s ago' },
  ]);

  const [starredBounties, setStarredBounties] = useState<number[]>(() => {
    const saved = localStorage.getItem("starredBounties");
    return saved ? JSON.parse(saved) : [];
  });
  const [starredProjects, setStarredProjects] = useState<number[]>(() => {
    const saved = localStorage.getItem("starredProjects");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("starredBounties", JSON.stringify(starredBounties));
  }, [starredBounties]);
  useEffect(() => {
    localStorage.setItem("starredProjects", JSON.stringify(starredProjects));
  }, [starredProjects]);

  const toggleStarBounty = (id: number) => {
    setStarredBounties(prev => prev.includes(id) ? prev.filter(bid => bid !== id) : [...prev, id]);
  };
  const toggleStarProject = (id: number) => {
    setStarredProjects(prev => prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]);
  };

  // Update the filtered lists based on activeCategory
  const filteredBounties = activeCategory === "ALL" ? BOUNTIES : BOUNTIES.filter(b => b.category === activeCategory);
  const filteredProjects = activeCategory === "ALL" ? PROJECTS : PROJECTS.filter(p => p.category === activeCategory);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab === 'BOUNTIES' || tab === 'PROJECTS' || tab === 'LEADERBOARD') {
      setMainTab(tab.toUpperCase() as any);
    }
  }, [location.search]);

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Unified card component for both bounties and projects
  const renderUnifiedCard = (item: typeof BOUNTIES[0] | typeof PROJECTS[0], type: 'bounty' | 'project') => (
    <div 
      key={type === 'bounty' ? (item as typeof BOUNTIES[0]).id : (item as typeof PROJECTS[0]).id}
      className="bg-[#FFE4E1] rounded-lg p-6 hover:bg-[#FFE4E1]/90 transition-colors cursor-pointer mb-4 border-2 border-black shadow-[4px_4px_0px_black]"
      onClick={() => {
        if (type === 'bounty') navigate(`/bounty/${(item as typeof BOUNTIES[0]).id}`);
        // Optionally, handle project details click here
      }}
    >
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-semibold text-lg flex items-center gap-2 text-black">
            {type === 'bounty' ? (item as typeof BOUNTIES[0]).title : (item as typeof PROJECTS[0]).name}
            {/* Star/favorite button for bounties/projects can go here */}
          </h3>
          <p className="text-black/70 mt-1">{type === 'bounty' ? (item as typeof BOUNTIES[0]).company : (item as typeof PROJECTS[0]).description}</p>
          <div className="flex gap-4 mt-3 text-sm text-black/60">
            {type === 'bounty' ? (
              <>
                <span className="bg-[#B5EAD7] px-2 py-1 rounded border border-black">Due in {(item as typeof BOUNTIES[0]).dueTime}</span>
                <span className="bg-[#B5EAD7] px-2 py-1 rounded border border-black">Comments: {(item as typeof BOUNTIES[0]).comments}</span>
              </>
            ) : (
              <>
                <span className="bg-[#B5EAD7] px-2 py-1 rounded border border-black">Tech: {(item as typeof PROJECTS[0]).tech.join(', ')}</span>
                <span className="bg-[#B5EAD7] px-2 py-1 rounded border border-black">Applied: {(item as typeof PROJECTS[0]).applied}</span>
                <span className="bg-[#B5EAD7] px-2 py-1 rounded border border-black">Stars: {(item as typeof PROJECTS[0]).stars}</span>
              </>
            )}
          </div>
        </div>
        <div className="text-right flex flex-col items-end gap-2">
          {type === 'bounty' && (
            <span className="text-lg font-bold text-black bg-[#C7CEEA] px-3 py-1 rounded border border-black">
              {(item as typeof BOUNTIES[0]).amount}
            </span>
          )}
          <Button 
            size="sm" 
            variant="default" 
            onClick={e => {
              e.stopPropagation();
              if (type === 'bounty') {
                if (user) {
                  navigate(`/bounty/${(item as typeof BOUNTIES[0]).id}/submit`);
                } else {
                  navigate("/login");
                }
              } else {
                if (user) {
                  navigate(`/project/${(item as typeof PROJECTS[0]).id}/apply`);
                } else {
                  navigate("/login");
                }
              }
            }}
            className="bg-[#C7CEEA] text-black border-2 border-black hover:bg-[#C7CEEA]/90 hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all shadow-[2px_2px_0px_black]"
          >
            {type === 'bounty' ? 'Submit' : 'Apply'}
          </Button>
        </div>
      </div>
    </div>
  );

  const renderBountyCard = (bounty: typeof BOUNTIES[0]) => (
    <div 
      key={bounty.id} 
      className="bg-white rounded-lg p-4 hover:bg-gray-100 transition-colors cursor-pointer mb-4 border shadow"
      onClick={() => navigate(`/bounty/${bounty.id}`)}
    >
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-semibold text-lg flex items-center gap-2">
            {bounty.title}
            <button
              onClick={e => { e.stopPropagation(); toggleStarBounty(bounty.id); }}
              className="ml-2"
              aria-label={starredBounties.includes(bounty.id) ? "Unstar" : "Star"}
            >
              <StarIcon
                className={starredBounties.includes(bounty.id) ? "text-yellow-400 fill-yellow-400" : "text-muted-foreground"}
                fill={starredBounties.includes(bounty.id) ? "#facc15" : "none"}
              />
            </button>
          </h3>
          <p className="text-muted-foreground">{bounty.company}</p>
          <div className="flex gap-4 mt-2 text-sm text-muted-foreground">
            <span>Due in {bounty.dueTime}</span>
            <span>•</span>
            <span>Comments: {bounty.comments}</span>
          </div>
        </div>
        <div className="text-right flex flex-col items-end gap-2">
          <span className="text-lg font-bold text-primary">{bounty.amount}</span>
          <Button size="sm" variant="default" onClick={e => {
            e.stopPropagation();
            if (user) {
              navigate(`/bounty/${bounty.id}/submit`);
            } else {
              navigate("/login");
            }
          }}>Submit</Button>
        </div>
      </div>
    </div>
  )

  const renderBountyDetail = (bounty: typeof BOUNTIES[0]) => (
    <div className="flex flex-col md:flex-row gap-8">
      {/* Back Button */}
      <div className="w-3 mb-4">
        <Button variant="ghost" onClick={() => setSelectedBounty(null)} className="flex items-center">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
      </div>
      {/* Left Section */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center">
            <span className="text-2xl font-bold text-primary">{bounty.company[0]}</span>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-xl md:text-2xl font-bold flex items-center gap-2">{bounty.title}
                <button
                  onClick={e => { e.stopPropagation(); toggleStarBounty(bounty.id); }}
                  className="ml-2"
                  aria-label={starredBounties.includes(bounty.id) ? "Unstar" : "Star"}
                >
                  <StarIcon
                    className={starredBounties.includes(bounty.id) ? "text-yellow-400 fill-yellow-400" : "text-muted-foreground"}
                    fill={starredBounties.includes(bounty.id) ? "#facc15" : "none"}
                  />
                </button>
              </h1>
              <Badge className="bg-green-600 text-white ml-2">Bounty</Badge>
            </div>
            <div className="text-muted-foreground">@{bounty.company.toLowerCase().replace(/ /g, '')}</div>
          </div>
        </div>
        <div className="flex items-center gap-2 mb-6">
          <div className="flex -space-x-2">
            {MOCK_BOUNTY_DETAIL.avatars.map((src, i) => (
              <img key={i} src={src} alt="avatar" className="w-8 h-8 rounded-full border-2 border-background" />
            ))}
          </div>
          <span className="text-sm text-muted-foreground ml-2">{MOCK_BOUNTY_DETAIL.interested} Interested</span>
        </div>
        {/* ABOUT */}
        <div className="mb-6">
          <div className="uppercase text-xs text-muted-foreground tracking-widest mb-2">About</div>
          <div className="bg-muted rounded-lg p-4 text-sm whitespace-pre-line">
            {MOCK_BOUNTY_DETAIL.about}
          </div>
        </div>
        {/* BOUNTY DETAILS */}
        <div className="mb-6">
          <div className="uppercase text-xs text-muted-foreground tracking-widest mb-2">Bounty Details</div>
          <div className="bg-muted rounded-lg p-4">
            <div className="flex items-center gap-4 mb-2 text-sm text-muted-foreground">
              <Clock className="w-4 h-4" /> Due in {bounty.dueTime}
            </div>
            <div className="font-semibold text-lg mb-1">{bounty.title}</div>
            <div className="text-sm text-muted-foreground whitespace-pre-line">{MOCK_BOUNTY_DETAIL.about}</div>
          </div>
        </div>
        {/* EVALUATION CRITERIA */}
        <div className="mb-6">
          <div className="uppercase text-xs text-muted-foreground tracking-widest mb-2">Apply Criteria</div>
          <div className="bg-muted rounded-lg p-4">
            <ul className="list-disc pl-5 space-y-1 text-sm">
              {(bounty.criteria || [
                'Criteria not specified.'
              ]).map((c: string, i: number) => (
                <li key={i}>{c}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {/* Right Section */}
      <div className="w-full md:w-80 flex-shrink-0">
        <div className="bg-card rounded-xl p-6 shadow-lg">
          <div className="uppercase text-xs text-muted-foreground tracking-widest mb-2">Project Deadline</div>
          <div className="text-lg font-mono mb-4">
            {MOCK_BOUNTY_DETAIL.deadline}
            <span className="text-muted-foreground text-sm ml-1">Remaining</span>
          </div>
          <div className="uppercase text-xs text-muted-foreground tracking-widest mb-2">Total Prizes</div>
          <div className="text-2xl font-bold mb-4 flex items-center gap-2">
            <Gem className="w-5 h-5 text-primary" />
            {bounty.amount}
          </div>
          <div className="mb-4">
            {MOCK_BOUNTY_DETAIL.prizes.map((prize, i) => (
              <div key={i} className="flex justify-between text-sm mb-1">
                <span>{prize.label}</span>
                <span className="font-semibold">{prize.amount} USDC</span>
              </div>
            ))}
          </div>
          <Button className="w-full" onClick={() => {
            if (user) {
              navigate(`/bounty/${bounty.id}/submit`);
            } else {
              navigate("/login");
            }
          }}>Submit</Button>
        </div>
      </div>
    </div>
  )

  const renderProjectCard = (project: typeof PROJECTS[0]) => (
    <ProjectCard
      key={project.id}
      name={project.name}
      description={project.description}
      tech={project.tech}
      applied={project.applied}
      stars={project.stars}
    />
  )
  
  return (
    <ThemeProvider>
      {/* <Navbar mainTab={mainTab} setMainTab={setMainTab} /> */}
      <div className="min-h-screen bg-[#F0F0FF]">
        {/* Banner */}
        <div className="px-20 pt-8">
          <div style={{
            backgroundColor: '#FF5629',
            border: '2px solid #000',
            borderRadius: '5px',
            boxShadow: '4px 4px 0px #000',
            padding: '28px 40px',
            marginBottom: '32px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            maxWidth: '672px',
            position: 'relative'
          }}>
            <div className="text-[32px] font-['OT_Bulb_Classic'] font-extrabold uppercase leading-[36px] text-[#110972] tracking-wide mb-2 border-2 border-black bg-[#C7CEEA] px-4 py-2 shadow-[2px_2px_0px_black]">Earn your first dollar on Base</div>
            <div className="text-[16px] font-['Public_Sans'] font-semibold leading-[20px] text-gray-800 bg-[#B5EAD7] border-2 border-black rounded-lg px-4 py-2 shadow-[2px_2px_0px_black] ml-2 mt-2">Start by contributing to the projects and participating in bounties.</div>
          </div>
        </div>
        {/* Main Content */}
        <div className="flex">
          <div className="flex-1 px-20">
            {/* Sub-tabs for Bounties/Projects */}
            {(mainTab === 'bounties' || mainTab === 'projects') && (
              <div className="flex gap-4 pt-6 pb-2">
                {['open', 'inprogress', 'completed'].map(subTab => (
                  <button
                    key={subTab}
                    onClick={() => mainTab === 'bounties' ? setBountySubTab(subTab as any) : setProjectSubTab(subTab as any)}
                    className={`h-[32px] px-4 font-semibold text-[14px] font-['Public_Sans'] uppercase transition-all transition-colors transition-shadow duration-200 rounded-sm
                      ${(mainTab === 'bounties' ? bountySubTab : projectSubTab) === subTab
                        ? 'bg-white text-[#1602F2] border border-black shadow-[2px_4px_0px_black]'
                        : 'bg-gray-100 text-gray-700 border border-transparent'}
                    `}
                  >
                    {subTab === 'open' ? 'Open' : subTab === 'inprogress' ? 'In Progress' : 'Completed'}
                  </button>
                ))}
              </div>
            )}

            {/* Content based on mainTab */}
            {mainTab === 'bounties' && (
              <>
                {bountySubTab === 'open' && filteredBounties.map(b => renderUnifiedCard(b, 'bounty'))}
                {bountySubTab === 'inprogress' && IN_PROGRESS_BOUNTIES.map(b => renderUnifiedCard(b, 'bounty'))}
                {bountySubTab === 'completed' && COMPLETED_BOUNTIES.map(b => renderUnifiedCard(b, 'bounty'))}
              </>
            )}
            {mainTab === 'projects' && (
              <>
                {projectSubTab === 'open' && filteredProjects.map(p => renderUnifiedCard(p, 'project'))}
                {projectSubTab === 'inprogress' && IN_PROGRESS_PROJECTS.map(p => renderUnifiedCard(p, 'project'))}
                {projectSubTab === 'completed' && COMPLETED_PROJECTS.map(p => renderUnifiedCard(p, 'project'))}
              </>
            )}
            {mainTab === 'leaderboard' && (
              <>
                <div className="w-full flex justify-start mb-6">
                  <div className="px-2 py-1 bg-white rounded-sm">
                    <span
                      className="text-[40px] font-['OT_Bulb_Classic'] font-extrabold uppercase tracking-tight text-blue-700"
                      style={{ letterSpacing: '0.04em', fontFamily: 'OT Brut, OT_Bulb_Classic, monospace' }}
                    >
                      LEADERBOARD
                    </span>
                  </div>
                </div>
                <Leaderboard leaders={leaders} />
              </>
            )}
          </div>
          {/* Show sidebar only for bounties and projects */}
          {(mainTab === 'bounties' || mainTab === 'projects') && <Sidebar />}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Home;
